
import CloseSVG from "../../../../icons/close";
import PrintSVG from "../../../../icons/print";
import Button from "../../../../button/button";
import Modal from "../../../../modal/modal";
import CashAuditPDF from "./CashAuditPDF";
// Function to generate and print the PDF receipt

const PrintCashAudit = ({ isOpen, onClose, auditData }) => {  // Cambia la forma en que recibes las props
    const handlePrint = async () => {
        const pdfDoc = await CashAuditPDF(auditData); // Generate the PDF
        // pdfDoc.autoPrint();
        window.open(pdfDoc.output('bloburl'), '_blank');
    };

    return (
        <Modal onClose={onClose} isOpen={isOpen} overlayClick={false}>
            <div className="print-receipt">
                <div className="title-contain">
                    <h1 className="title-3">Corte realizado</h1>
                    <p>El corte se ha realizado exitosamente. ¿Que desea hacer a continuación?</p>
                </div>

                <div className="print-receipt-buttons">
                    <Button text="Imprimir corte" Icon={PrintSVG} onClick={handlePrint} />
                    <Button text="Cerrar" Icon={CloseSVG} onClick={onClose}/>
                </div>
            </div>
        </Modal>
    );
};


export default PrintCashAudit;
